(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/account-selector.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/account-selector.js');

'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  Button
} = svs.ui;
const {
  helpers,
  AccountSelectorModal,
  AccountsDropdown
} = svs.components.marketplace.accountSelector;
const {
  products
} = svs.utils;
class AccountSelector extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isVisible: false
    });
    _defineProperty(this, "addGroupIdToUrl", selectedId => {
      const defaultPath = document.location.origin + document.location.pathname;
      if (selectedId !== 'user') {
        history.replaceState({}, '', "".concat(defaultPath, "?activatedDrawId=").concat(selectedId));
      } else {
        history.replaceState({}, '', defaultPath);
      }
      svs.utils.url.refreshQueryString();
    });
    _defineProperty(this, "handleDone", selectedId => {
      this.addGroupIdToUrl(selectedId);
      this.setState({
        isVisible: false
      });
      helpers.observer.notify({
        accounts: helpers.observer.getValue().accounts
      });
    });
    _defineProperty(this, "shouldInvertBtn", () => {
      if (this.props.btnInversion) {
        return true;
      }
      return false;
    });
  }
  render() {
    const {
      productId,
      accounts,
      drawNumber,
      userAccountBalance,
      selectedId
    } = this.props;
    const {
      isVisible
    } = this.state;
    const shouldHideChangeSaldoButton = svs.utils.url.queryString.fromPlayTogether === 'true' || svs.utils.url.queryString.isRetailerAdmin === 'true';
    if (!(accounts !== null && accounts !== void 0 && accounts.length) > 0 || shouldHideChangeSaldoButton) {
      return React.createElement("div", {
        "data-testid": "qa-account-selector-empty"
      });
    }
    const hasDropdown = productId === products.productIds.RACING || productId === products.productIds.CHALLENGE;
    return React.createElement("div", {
      "data-testid": "qa-account-selector"
    }, hasDropdown ? React.createElement(AccountsDropdown, {
      data: accounts,
      defaultSelected: selectedId,
      onDone: this.handleDone,
      productId: productId,
      selectedId: selectedId,
      userAccountBalance: userAccountBalance
    }) : React.createElement(React.Fragment, null, React.createElement(Button, {
      block: true,
      className: "qa-account-selector-btn",
      "data-testid": "qa-account-selector-btn",
      inverted: this.shouldInvertBtn(),
      onClick: () => {
        svs.components.marketplace.accountSelector.helpers.fetchGames({
          drawNumber,
          productId,
          options: {
            ignoreCache: true
          }
        }, () => {
          this.setState({
            isVisible: true
          });
        });
      },
      size: 90,
      transparent: true,
      type: "button"
    }, "Byt saldo"), isVisible && React.createElement(AccountSelectorModal, _extends({
      data: accounts,
      defaultSelected: selectedId,
      onDone: this.handleDone,
      productId: productId,
      userAccountBalance: userAccountBalance
    }, this.props))));
  }
}
setGlobal('svs.components.marketplace.accountSelector.AccountSelector', AccountSelector);

 })(window);